(function() {

    var STACK_ELEMENT_GAP       = 20;   // Gap between stacking elements
    var MIN_OFFSET_FOR_STACKING = 400;  // Minimum white space needed for enabling sticky stack
    var RECOMPUTE_INTERVAL      = 7e3;  // Recompute stack every n interval

    var stickyNav = document.querySelector(".top-nav-sticky");
    var stackable = document.querySelector(".stackable.stackable--enabled");
    var stackableElements = (stackable && [].slice.call(stackable.children)) || [];

    function log(msg) {
        return window.console && window.console.log('[stackable.js]: ' + msg);
    }

    function elOffsetTop(el) {
        return 'string' === typeof el ? document.querySelector(el).offsetTop : el.offsetTop;
    }

    function validStackableElements() {
        var elements = [];
        var totalHeight = 0;
        stackableElements.forEach(function(el) {
            var h = elOffsetHeight(el);
            var w = elOffsetWidth(el);
            if (h > 0 && w > 0) {
                totalHeight = totalHeight + h;
                elements.push(el);
            }
        });
        return { elements: elements, totalHeight: totalHeight };
    }

    function elOffsetHeight(el) {
        return 'string' === typeof el ? document.querySelector(el).offsetHeight :  el.offsetHeight;
    }

    function elOffsetWidth(el) {
        return 'string' === typeof el ? document.querySelector(el).offsetWidth :  el.offsetWidth;
    }

    function stickyNavOffset() {
        return elOffsetHeight(stickyNav) + STACK_ELEMENT_GAP;
    }

    function stackableArea() {
        return elOffsetHeight(stackable.parentElement) - elOffsetTop(stackable);
    }

    function stackableElementOffset(elements) {
        return Math.floor(stackableArea() / (elements.length));
    }

    function hasStackableElements() {
        return stackable && stackableElements.length > 0;
    }

    function hasStackableSpace(totalHeight) {
        return stackableArea() - totalHeight > MIN_OFFSET_FOR_STACKING;
    }

    function scrollYPos() {
        return window.pageYOffset - stickyNavOffset();
    }

    function setStackableAttr(el, name, val) {
        return el.setAttribute('data-stackable-' + name, val);
    }

    function getStackableIntVal(el, name) {
        return (el.getAttribute('data-stackable-' + name) && parseInt(el.getAttribute('data-stackable-' + name), 10)) || null;
    }

    function getTopPos(el) {
        return getStackableIntVal(el, 'top-pos');
    }

    function getBottomPos(el) {
        return getStackableIntVal(el, 'bottom-pos');
    }

    function getHeight(el) {
        return getStackableIntVal(el, 'height');
    }

    function computeStack(elements, forceCompute) {
        var heightBuffer = 0;   // To compute correct position from top
        var compute = forceCompute || false;
        elements.forEach(function(el, i) {
            var elemHeight = elOffsetHeight(el);
            var cachedHeight = getHeight(el);
            if ( cachedHeight == null || elemHeight !== cachedHeight ) { compute = true; }
            if (compute) {
                heightBuffer += (elements[i - 1] && elOffsetHeight(elements[i - 1]) || 0);
                var topPos = (elOffsetTop(stackable) + heightBuffer) + (stackableElementOffset(elements) * i) + STACK_ELEMENT_GAP;
                el.style.position = 'absolute';
                el.style.top = topPos + 'px';
                setStackableAttr(el, 'top-pos', topPos);
            }
        });

        elements.forEach(function(el, i) {
            if (compute) {
                var nextEl = elements[i + 1] || null;
                var elHeight = elOffsetHeight(el);
                var bottomPos = ((nextEl && (getTopPos(nextEl) - elHeight)) || ((elOffsetHeight(stackable.parentElement) + elOffsetTop(stackable.parentElement)) - elHeight)) - STACK_ELEMENT_GAP;
                setStackableAttr(el, 'bottom-pos', bottomPos);
                setStackableAttr(el, 'height', elHeight);
            }
        });
    }

    function stickElements(elements) {
        var yPos = scrollYPos();
        elements.forEach(function(el) {
            var topPos = getTopPos(el);
            var bottomPos = getBottomPos(el);
            var stickElement = yPos > topPos && yPos < bottomPos;
            if ( stickElement ) {
                el.style.position = 'fixed';
                el.style.top = stickyNavOffset() + 'px';
            } else {
                var pos = yPos > topPos ? bottomPos : topPos;
                el.style.position = 'absolute';
                el.style.top = (pos - STACK_ELEMENT_GAP) + 'px';
            }
        });
    }

    function resetElements(elements) {
        elements.forEach(function(el){
            if ( el.style.position !== 'relative') {
                el.style.position = 'relative';
                el.style.top = '0';
            }
        });
    }

    function computeAndStick(forceCompute) {
        forceCompute = forceCompute || false;
        var valid = validStackableElements();
        if ( valid.elements.length ) {
            if ( hasStackableSpace(valid.totalHeight) ) {
                computeStack(valid.elements, forceCompute);
                stickElements(valid.elements);
            } else {
                log('Not enough min space ('+MIN_OFFSET_FOR_STACKING+'px) available to stack elements');
                resetElements(valid.elements);
            }
        } else {
            log('No valid stackable elements found');
        }
    }

    if (hasStackableElements()) {
        log('Stackable elements found');

        if (stackable) {
            stackable.style.paddingTop = STACK_ELEMENT_GAP + 'px';
        }

        computeAndStick();
        window.addEventListener('scroll', function() { computeAndStick(); });

        // Compute stack on RR FB module render
        waitForGlobal('FB', function(){
            FB.Event.subscribe('xfbml.render', function() {
                computeAndStick(true);
            });
        });

        // Maybe should not hurt computing stack every set interval
        // if client window is not scrolled and a stackable element height updates
        setInterval(function(){
            computeAndStick(true);
        }, RECOMPUTE_INTERVAL);
    }

})();
